import { Stack, type SxProps } from '@mui/material'
import { DeleteProvider } from './DeleteProvider'
import { useGetAllProviders } from './hooks/useGetAllProviders'
import { useModal } from './hooks/useModal'
import { Modal } from './Modal'
import { TransferOwnership } from './TransferOwnership'

const sx: SxProps = {
  height: 56,
  minWidth: 194,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
}

export function ProviderManagementPage() {
  const { options } = useGetAllProviders()
  const { modalState, openModal, closeModal } = useModal()
  const props = { options, openModal, sx }
  return (
    <>
      <Stack alignItems="center" gap={6}>
        <TransferOwnership {...props} />
        <DeleteProvider {...props} />
      </Stack>
      <Modal modalState={modalState} closeModal={closeModal} />
    </>
  )
}
